export { isRouteInMainTab } from './isRouteInMainTab';
